export default {
  windowWidth: 0,
  shallShowOverlay: false,
  locales: ['ar', 'en'],
  language: {
    locale: 'ar',
    rtl: 'rtl',
    rtl2: 'rtl.',
    direction: 'right',
  },
  messages: 'success',
  loading: false,
};
